(function () {
    "use strict";

    // Taken from https://stackoverflow.com/a/55343474
    angular.module("app").directive("habilBlacklist", BlacklistDirectiveFactory);

    BlacklistDirectiveFactory.$inject = ["$parse",];
    function BlacklistDirectiveFactory($parse) {
        return {
            restrict: "A",
            require: "ngModel",
            link: function (scope, _elem, attr, ngModel) {
                ngModel.$validators.blacklist = function (modelValue, viewValue) {
                    const blacklistAttribute = attr.habilBlacklist;

                    const blacklist = angular.isString(blacklistAttribute) ? $parse(attr.habilBlacklist)(scope) : attr.habilBlacklist;

                    const value = modelValue || viewValue;

                    return blacklist.indexOf(value) === -1;
                };                 
            }
        };
    }
})();
